import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const SavedItemsService = {
  async toggleSave(itemId, itemType, displayData, authHeaders) {
    const response = await axios.post(
      `${apiUrl}/saved-items/toggle`,
      { item_id: itemId, item_type: itemType, ...displayData },
      authHeaders
    );
    return response.data;
  },

  async getSaveStatus(itemId, itemType, authHeaders) {
    const response = await axios.get(
      `${apiUrl}/saved-items/status?item_id=${encodeURIComponent(itemId)}&item_type=${encodeURIComponent(itemType)}`,
      authHeaders
    );
    return response.data;
  },

  async getUserSavedItems(authHeaders) {
    const response = await axios.get(`${apiUrl}/saved-items`, authHeaders);
    return response.data;
  },

  async toggleGoing(itemId, itemType, authHeaders) {
    const response = await axios.post(
      `${apiUrl}/saved-items/going`,
      { item_id: itemId, item_type: itemType },
      authHeaders
    );
    return response.data;
  },
};

export default SavedItemsService;
